import React from 'react';
import PersonIcon from '@mui/icons-material/Person';
import AddIcon from '@mui/icons-material/Add';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch } from 'react-redux';
import useTailwindBrand from 'src/Theme/useTailwindBrand';
import FormInput from 'src/Components/Ui/FormInput';
import FormSelect from 'src/Components/FormFields/FormSelect';
import FormRadioYesNo from 'src/Components/FormFields/FormRadioYesNo';
import FormSection from 'src/Components/FormFields/FormSection';
import FormDate from 'src/Components/FormFields/FormDate';
import DialogLayout from 'src/Components/DialogLayout';
import { useProcuration } from 'src/Hooks/useProcuration';
import { useProcurationContext } from 'src/Contexts/ProcurationContext';
import { DialogErrors, FormErrorsFourthPart, LegalRepresentative } from 'src/Hooks/InterfaceProcuration';
import LayoutProcuration from 'src/Components/Procuration/LayoutProcuration';

const FourthPartAe = () => {
    const { classes } = useTailwindBrand();
    const dispatch = useDispatch();
    const context = useProcurationContext();
    const { teachr, prevStep, nextStep, pdfDoc, triggerPdfUpdate, generalProcuration, setPage } = context;

    const {
        formDataFourthPart,
        errorsFourthPart,
        legalRepresentatives,
        openDialog,
        dialogErrors,
        pdfFiledFieldsFourth,
        dialogFormData,
        setFormDataFourthPart,
        setErrorsFourthPart,
        handleSelect,
        setRenounceInsaisissabilityField,
        setAddCommercialNameField,
        setEmployEmployeesField,
        setEmployeeCountField,
        setAddOtherLegalRepresentativesField,
        setLegalRepresentatives,
        setOpenDialog,
        setDialogFormData,
        setDialogErrors,
        handleChange,
        setOtherChiefGenderField,
        setOtherChiefNationalField
    } = useProcuration({ pdfDoc, teachr, triggerPdfUpdate, setPage });

    const valuesFourth = {
        setField: setFormDataFourthPart,
        error: errorsFourthPart,
        setError: setErrorsFourthPart
    }

    const valuesDialog = {
        setField: setDialogFormData,
        error: dialogErrors,
        setError: setDialogErrors
    }



    const validate = (): boolean => {
        const newErrorsFourth: FormErrorsFourthPart = {
            renounceInsaisissability: formDataFourthPart.renounceInsaisissability === 0 ? 'Veuillez répondre à cette question' : '',
            addCommercialName: formDataFourthPart.addCommercialName === 0 ? 'Veuillez répondre à cette question' : '',
            employEmployees: formDataFourthPart.employEmployees === 0 ? 'Veuillez répondre à cette question' : '',
            employeeCount: formDataFourthPart.employEmployees === 1 && formDataFourthPart.employeeCount === 0 ? 'Veuillez sélectionner le nombre de salariés' : '',
            addOtherLegalRepresentatives: formDataFourthPart.addOtherLegalRepresentatives === 0 ? 'Veuillez répondre à cette question' : '',
        };
        setErrorsFourthPart(newErrorsFourth);
        return !Object.values(newErrorsFourth).some(error => error !== '');
    };

    const validateDialog = (): boolean => {
        const newErrors: DialogErrors = {
            firstName: dialogFormData.firstName.trim() === '' ? 'Veuillez renseigner un prénom' : '',
            lastName: dialogFormData.lastName.trim() === '' ? 'Veuillez renseigner un nom' : '',
            birthDate: dialogFormData.birthDate === '' ? 'Veuillez renseigner une date de naissance' : '',
            birthCountry: dialogFormData.birthCountry.trim() === '' ? 'Veuillez renseigner un pays' : '',
            gender: dialogFormData.gender === 0 ? 'Veuillez sélectionner un genre' : '',
            nationality: dialogFormData.nationality === 0 ? 'Veuillez sélectionner une nationalité' : ''
        };
        setDialogErrors(newErrors);
        return !Object.values(newErrors).some(error => error !== '');
    };

    const handleDialogDateChange = (value: string) => {
        setDialogFormData(prev => ({ ...prev, birthDate: value }));
        if (dialogErrors.birthDate) {
            setDialogErrors(prev => ({ ...prev, birthDate: '' }));
        }
    };

    const handleAddRepresentative = () => {
        if (validateDialog()) {
            const newRepresentative: LegalRepresentative = {
                id: Date.now().toString(),
                firstName: dialogFormData.firstName,
                lastName: dialogFormData.lastName,
                birthDate: dialogFormData.birthDate,
                birthCountry: dialogFormData.birthCountry,
                gender: dialogFormData.gender,
                nationality: dialogFormData.nationality
            };
            setLegalRepresentatives(prev => [...prev, newRepresentative]);
            setDialogFormData({
                firstName: '',
                lastName: '',
                birthDate: '',
                birthCountry: '',
                gender: 0,
                nationality: 0
            });
            setDialogErrors({
                firstName: '',
                lastName: '',
                birthDate: '',
                birthCountry: '',
                gender: '',
                nationality: ''
            });
            setOpenDialog(false);
        }
    };

    const handleRemoveRepresentative = (id: string) => {
        setLegalRepresentatives(prev => prev.filter(rep => rep.id !== id));
    };

    const handleNext = () => {
        if (validate()) {
            const payload = {
                step: 6,
                secondProc: generalProcuration?.secondProc || {},
                thirdProc: generalProcuration?.thirdProc || {},
                fourthProc: generalProcuration?.fourthProc || {},
                fifthProc: generalProcuration?.fifthProc || {},
                sixthProc: formDataFourthPart,
                legalRepProc: JSON.parse(JSON.stringify(legalRepresentatives)),
                seventhProc: generalProcuration?.seventhProc || {},
                eightProc: generalProcuration?.eightProc || {}
            };
            dispatch({ type: 'SET_AE_INFO', payload });
            nextStep(6);
        }
    };

    return (
        <LayoutProcuration
            title="Informations complémentaires"
            icon={<PersonIcon className={`w-6 h-6 ${classes.primaryText}`} />}
            nextStep={handleNext}
            prevStep={prevStep}
            currentStep={3}
            totalSteps={4}
        >
            {/* <div className="space-y-2"> */}
            <FormSection title="Options de votre micro-entreprise">
                <div className="space-y-0">
                    <FormRadioYesNo
                        label="Par défaut votre résidence principale est insaisissable, souhaitez-vous renoncer à cette insaisissabilité ?"
                        value={formDataFourthPart.renounceInsaisissability}
                        onChange={(value) => handleSelect(value, 'renounceInsaisissability', setRenounceInsaisissabilityField, valuesFourth, 3)}
                        error={errorsFourthPart.renounceInsaisissability}
                        required={true}
                        name="renounceInsaisissability"
                    />

                    <FormRadioYesNo
                        label="Souhaitez-vous ajouter un nom commercial ?"
                        value={formDataFourthPart.addCommercialName}
                        onChange={(value) => handleSelect(value, 'addCommercialName', setAddCommercialNameField, valuesFourth, 4)}
                        error={errorsFourthPart.addCommercialName}
                        required={true}
                        name="addCommercialName"
                    />

                    <FormRadioYesNo
                        label="Employez-vous des salariés ?"
                        value={formDataFourthPart.employEmployees}
                        onChange={(value) => handleSelect(value, 'employEmployees', setEmployEmployeesField, valuesFourth, 4)}
                        error={errorsFourthPart.employEmployees}
                        required={true}
                        name="employEmployees"
                    />

                    {formDataFourthPart.employEmployees === 1 && (
                        <FormSelect
                            callback={(value) => handleSelect(value, 'employeeCount', setEmployeeCountField, valuesFourth, 4)}
                            required={true}
                            error={errorsFourthPart.employeeCount}
                            label="Combien de salariés ?"
                            placeholder="Sélectionner le nombre"
                            data={['1', '2', '3', '4', '5', '6', '7', '8', '9', '10']}
                            customClass={`bg-white ${classes.fontFamily} py-[6px] shadow-md shadow-[rgba(0,0,0,25%)] text-[16px] border ${errorsFourthPart.employeeCount ? `${classes.errorBorder} border-l-4` : 'hover:border-2 hover:border-gray-400'}`}
                            defaultValue={formDataFourthPart.employeeCount}
                        />
                    )}

                    <FormRadioYesNo
                        label="Souhaitez-vous ajouter d'autres représentants légaux pour votre micro-entreprise ?"
                        value={formDataFourthPart.addOtherLegalRepresentatives}
                        onChange={(value) => handleSelect(value, 'addOtherLegalRepresentatives', setAddOtherLegalRepresentativesField, valuesFourth, 3)}
                        error={errorsFourthPart.addOtherLegalRepresentatives}
                        required={true}
                        name="addOtherLegalRepresentatives"
                    />

                    {/* Liste des représentants légaux */}
                    {formDataFourthPart.addOtherLegalRepresentatives === 1 && (
                        <div className="space-y-4 pt-4 border-t border-gray-200">
                            {legalRepresentatives.length > 0 && (
                                <div className="space-y-3">
                                    {legalRepresentatives.map((rep) => (
                                        <div
                                            key={rep.id}
                                            className="flex justify-between items-center py-3 px-4 bg-blue-50 border border-blue-200 rounded-lg"
                                        >
                                            <div className="flex items-center gap-3">
                                                <CheckCircleIcon className="text-green-500 w-5 h-5" />
                                                <span className={`${classes.fontFamily} font-semibold text-gray-900`}>
                                                    {rep.firstName} {rep.lastName}
                                                </span>
                                            </div>
                                            <button
                                                onClick={() => handleRemoveRepresentative(rep.id)}
                                                className="p-2 hover:bg-red-50 rounded-lg transition-colors"
                                                aria-label="Supprimer le représentant"
                                            >
                                                <DeleteIcon className="text-red-500 w-5 h-5" />
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            )}

                            <button
                                onClick={() => setOpenDialog(true)}
                                className="flex items-center justify-center gap-3 w-full p-4 bg-white border-2 border-dashed border-gray-300 rounded-lg hover:border-blue-400 hover:bg-blue-50 transition-all cursor-pointer"
                            >
                                <AddIcon className="text-gray-400" />
                                <span className={`${classes.fontFamily} font-semibold text-gray-700`}>
                                    Ajouter un représentant légal
                                </span>
                            </button>
                        </div>
                    )}
                </div>
            </FormSection>
            {/* Dialog pour ajouter un représentant légal */}
            <DialogLayout
                title="Ajouter un représentant légal"
                text=""
                open={openDialog}
                handleClose={() => {
                    setOpenDialog(false);
                    setDialogFormData({
                        firstName: '',
                        lastName: '',
                        birthDate: '',
                        birthCountry: '',
                        gender: 0,
                        nationality: 0
                    });
                    setDialogErrors({
                        firstName: '',
                        lastName: '',
                        birthDate: '',
                        birthCountry: '',
                        gender: '',
                        nationality: ''
                    });
                }}
                handleSubmit={handleAddRepresentative}
                valid="Ajouter"
                cancel="Annuler"
                maxWidth="md"
            >
                <div className="space-y-6 pt-4">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                        <FormInput
                            label="Prénom"
                            type="text"
                            placeholder="Julie"
                            value={dialogFormData.firstName}
                            error={dialogErrors.firstName}
                            onChange={(e) => handleChange({ field: 'firstName', pdfField: pdfFiledFieldsFourth.otherChiefFirstNameField }, e, valuesDialog, 4, true)}
                            // onChange={(e) => handleChange('firstName', e, dialogFormData, setDialogFormData, setDialogErrors)}
                            name="firstName"
                            required
                        />

                        <FormInput
                            label="Nom de naissance"
                            type="text"
                            placeholder="Dupont"
                            value={dialogFormData.lastName}
                            error={dialogErrors.lastName}
                            // onChange={handleDialogInputChange('lastName')}
                            onChange={(e) => handleChange({ field: 'lastName', pdfField: pdfFiledFieldsFourth.otherChiefNameField }, e, valuesDialog, 4, true)}
                            name="lastName"
                            required
                        />

                        <FormDate
                            label="Date de naissance"
                            defaultValue={dialogFormData.birthDate}
                            callback={handleDialogDateChange}
                            required={true}
                            error={dialogErrors.birthDate}
                            className={`border rounded-md ${dialogErrors.birthDate ? `${classes.errorBorder} border-l-4` : 'hover:border-2 hover:border-gray-400'}`}
                        />

                        <FormInput
                            label="Pays de naissance"
                            type="text"
                            placeholder="France"
                            value={dialogFormData.birthCountry}
                            error={dialogErrors.birthCountry}
                            // onChange={handleDialogInputChange('birthCountry')}
                            onChange={(e) => handleChange({ field: 'birthCountry', pdfField: pdfFiledFieldsFourth.otherChiefbirthCountryField }, e, valuesDialog, 4, true)}
                            name="birthCountry"
                            required
                        />

                        <FormSelect
                            // callback={(value) => handleDialogSelectChange(value, 'gender')}
                            callback={(value) => handleSelect(value, 'gender', setOtherChiefGenderField, valuesDialog, 4, true)}
                            required={true}
                            error={dialogErrors.gender}
                            label="Genre"
                            placeholder="Sélectionner un genre"
                            data={['Femme', 'Homme']}
                            customClass={`bg-white ${classes.fontFamily} py-[6px] shadow-md shadow-[rgba(0,0,0,25%)] text-[16px] border ${dialogErrors.gender ? `${classes.errorBorder} border-l-4` : 'hover:border-2 hover:border-gray-400'}`}
                            defaultValue={dialogFormData.gender}
                        />

                        <FormSelect
                            // callback={(value) => handleDialogSelectChange(value, 'nationality')}
                            callback={(value) => handleSelect(value, 'nationality', setOtherChiefNationalField, valuesDialog, 4, true)}
                            required={true}
                            error={dialogErrors.nationality}
                            label="Nationalité"
                            placeholder="Sélectionner une nationalité"
                            data={['Française', 'Étrangère']}
                            customClass={`bg-white ${classes.fontFamily} py-[6px] shadow-md shadow-[rgba(0,0,0,25%)] text-[16px] border ${dialogErrors.nationality ? `${classes.errorBorder} border-l-4` : 'hover:border-2 hover:border-gray-400'}`}
                            defaultValue={dialogFormData.nationality}
                        />
                    </div>
                </div>
            </DialogLayout>
            {/* </div> */}
        </LayoutProcuration>
    );
};

export default FourthPartAe;
